import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const FALLBACK = {
  brand_name: "OFFCRAFT",
  tagline: "",
  whatsapp_number: "",
  packages: [],
  maintenance_plan: null,
  offers: null,
  notes: {},
  contact: {},
};

const Ctx = createContext(FALLBACK);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch (e) {
      /* keep fallback */
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return <Ctx.Provider value={{ config, loading, refresh }}>{children}</Ctx.Provider>;
};

export const useConfig = () => useContext(Ctx);
